export default "__VITE_ASSET__BUde8aua__"